import { useQueries } from "@tanstack/react-query";
import { useRouter } from "next/router";

import productCore from "../core/product.core";
import { getCartItemMaxQuantity } from "../core/pointRedemption.core";
import { Cart } from "../types/cart";

export function useCartStockStatus(cart: Cart | undefined) {
  const { locale, isReady } = useRouter();

  const stockCheckItems =
    cart?.items.filter((item) => !item.addOnDiscount && item.product.productType !== "giftCard") ?? [];

  const uniqueProductIds = [
    ...new Set(
      stockCheckItems.filter((item) => item.product.productType !== "bundle").map((item) => item.product.id)
    ),
  ];

  const queries = useQueries({
    queries: uniqueProductIds.map((productId) => ({
      queryKey: ["product", productId, locale],
      queryFn: () => productCore.getSingle(productId, locale!),
      enabled: isReady && !!locale,
    })),
  });

  const productMap = new Map(uniqueProductIds.map((id, index) => [id, queries[index]?.data]));
  const isLoading = queries.some((query) => query.isLoading);

  const hasStockIssue = stockCheckItems.some((item) => {
    const productForInventory =
      item.product.productType === "bundle" ? item.product : productMap.get(item.product.id) ?? item.product;
    const inventory = productCore.getSimpleProductInventoryCount(productForInventory);
    const maxQuantity = getCartItemMaxQuantity(item, inventory);

    if (maxQuantity === undefined) return false;
    return maxQuantity <= 0 || item.quantity > maxQuantity;
  });

  return { hasStockIssue, isLoading };
}
